import React from 'react';
import { Image } from 'react-bootstrap';

class LoadingSpinner extends React.Component {
	render() {
		return (
			<div
				className="loading-wrapper d-flex justify-content-center align-items-center"
				style={{ height: '60vh' }}
			>
				<Image
					src="https://static.dealer.com/v9/media/images/ajax-loaders/v1/white-ajax-loader-2.gif"
					width="32"
					height="32"
				/>
			</div>
		);
	}
}
export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.jsx